export default __webpack_public_path__ + "static/media/reset-password.9da88ed0.jpeg";